module.exports = __webpack_public_path__ + "media/images/pic/newsletter-3a05a5fd541ecf45ba8f604a4c52d36e.png";